import { cellStyle } from "../../../../components/Table/Table.styles";
import { OfficeStatus } from "../../../../enums";

// define your columns
export const getColumns = () => {
  return [
    {
      title: "Office Name",
      field: "name",
      align: "left",
      cellStyle: cellStyle,
    },
    {
      title: "Address",
      field: "address",
      cellStyle: cellStyle,
      searchable: false,
      customFilterAndSearch: null,
    },
    {
      title: "Status",
      field: "status",
      cellStyle: cellStyle,
      searchable: false,

      render: (role: any) => {
        return <>{OfficeStatus[role.status]}</>;
      },
      customFilterAndSearch: null,
    },
    {
      title: "Company",
      field: "company",
      align: "left",
      cellStyle: cellStyle,
      searchable: false,
      customFilterAndSearch: null,
    },
    {
      title: "Corporate Wifi",
      field: "corporateWifi",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: null,
    },
    {
      title: "Guest Wifi",
      field: "guestWifi",
      align: "left",
      searchable: false,
      cellStyle: cellStyle,
      customFilterAndSearch: null,
    },
    {
      title: "Members",
      field: "members",
      type: "numeric",
      align: "left",
      searchable: false,

      cellStyle: cellStyle,
      customFilterAndSearch: null,
    },
    {
      title: "Created",
      field: "createdAt",
      align: "left",
      searchable: false,
      cellStyle: cellStyle,
      customFilterAndSearch: null,
    },
  ];
};
